<template v-slot:activator="{ on }">
  <v-dialog
    v-model="exibedialogInterno"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="fechaDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Itens da Nota Fiscal</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            dark
            text
            @click="fechaDialog()"
          >
            Fechar
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider />
      <!-- CARD EMPRESA -->
      <card-empresa
        class="ma-2 ml-2 mr-2"
        :empresa="empresaNota"
      />
      <v-container v-if="exibeBtnDownload">
        <v-btn
          id="btnDownload"
          class="button__full"
          elevation="2"
          fab
          small
          color="primary"
          floating
          @click="generatePDF()"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </v-container>
      <!-- TABELA -->
      <v-simple-table>
        <thead>
          <tr style="text-weight=bold">
            <th class="primary--text">
              Nome
            </th>
            <th class="primary--text text-right">
              Qtde
            </th>
            <th class="primary--text text-right">
              Preço
            </th>
            <th class="primary--text text-right">
              Total
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in itensNota"
            :key="index"
          >
            <td
              class="text-left"
            >
              {{ item.nome }}
            </td>
            <td
              class="text-right"
            >
              {{ parseMoeda(item.quantidade,2) }}
            </td>
            <td
              class="text-right"
            >
              {{ parseMoeda(item.preco,2) }}
            </td>
            <td
              class="text-right"
            >
              {{ parseMoeda(item.valortotalitem,2) }}
            </td>
          </tr>
        </tbody>
        <tfoot
          class="totalizador"
        >
          <td />
          <td />
          <td />
          <td
            class="text-right"
          >
            {{ computedSomaValorTotalItem }}
          </td>
        </tfoot>
      </v-simple-table>
      <!-- card 1 e 2 -->
      <!-- <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-card
            class="mx-auto ml-2 mr-2 mb-0"
            outlined
            elevation="1"
          >
            <v-list-item>
              <v-list-item-content class="text--secondary">
                <b>Total Leite Bom: </b>{{ parseMoeda(recibo.leitebom,4) }}
              </v-list-item-content>
              <v-list-item-content class="text--secondary">
                <b>Total Geral Leite: </b>{{ parseMoeda(recibo.leitebom + recibo.leiteacido,4) }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="text--secondary">
                <b>Preço Médio: </b>R$ {{ parseMoeda(recibo.precomedio,4) }}
              </v-list-item-content>
              <v-list-item-content class="text--secondary">
                <b>Liquido a Receber: </b>R$ {{ parseMoeda(recibo.total,4) }}
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-card
            class="mx-auto ml-2 mr-2 mb-0"
            outlined
            elevation="1"
          >
            <v-list-item>
              <v-list-item-content class="text--secondary">
                <b>Banco: </b>{{ recibo.banco }}
              </v-list-item-content>
              <v-list-item-content class="text--secondary">
                <b>Agência: </b>{{ recibo.agencia }}
              </v-list-item-content>
              <v-list-item-content class="text--secondary">
                <b>Conta: </b>{{ recibo.conta }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="text--secondary">
                <b>Titular: </b>{{ recibo.titular }}
              </v-list-item-content>
              <v-list-item-content class="text--secondary">
                <b>CPF Titular: </b>{{ recibo.cpftitular }}
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row> -->
      <!-- CARD OBSERVACAO -->
      <v-row>
        <v-col
          cols="12"
        >
          <v-card
            class="mx-auto ml-2 mt-0 mr-2"
            outlined
            elevation="1"
          >
            <v-list-item>
              <v-list-item-content class="text--secondary">
                <b>Número: </b>{{ nota.numeronota }}
              </v-list-item-content>
              <v-list-item-content
                class="text--secondary"
                style="padding-right: 40px;"
              >
                <b>Chave: </b>{{ nota.chavenfe }}
              </v-list-item-content>
              <v-list-item-content class="text--secondary">
                <b>Emissão: </b>{{ formatDiaMesAno(nota.dataemissao) }}
              </v-list-item-content>
              <v-list-item-content class="text--secondary">
                <b>Incentivo: </b>{{ parseMoeda(nota.incentivo, 2) }}
              </v-list-item-content>
              <v-list-item-content class="text--secondary">
                <b>Total da nota: </b>{{ computedSomaValorTotalNota }}
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
  import CardEmpresa from '../component/CardEmpresa'
  import utils from '../../../services/utils'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardFormsItensReciboForm',
    components: {
      CardEmpresa,
    },
    mixins: [CardEmpresa, utils],
    props: {
      nota: {
        type: Object,
        default: function () {
          return {
            banco: '',
            agencia: '',
            conta: '',
            titular: '',
            total: '',
            cpftitular: '',
            leitebom: 0,
            precomedio: 0,
            chavenfe: '',
            versarnfe: 0,
          }
        },
      },
      itensNota: {
        type: Array,
        default: function () {
          return [{
            nome: '',
            valortotalitem: 0,
            preco: 0,
            quantidade: 0,
          }]
        },
      },
      exibeDialog: {
        type: Boolean,
        default: false,
      },
      empresaNota: {
        type: Object,
        default: function () {
          return {}
        },
      },
      bodyData: {
        type: Array,
        default: function () {
          return []
        },
      },
    },

    data: () => ({
      exibedialogInterno: false,
    }),

    computed: {
      computedSomaValorTotalItem () {
        return this.parseMoeda(this.itensNota.reduce((soma, item) => soma + item.valortotalitem, 0), 2)
      },
      computedSomaValorTotalNota () {
        return this.parseMoeda(this.itensNota.reduce((soma, item) => soma + item.valortotalitem + item.incentivo, 0), 2)
      },
    },

    watch: {
      exibeDialog: function (val) {
        this.exibedialogInterno = val
      },
    },

    methods: {
      fechaDialog () {
        this.exibedialogInterno = false
        this.$emit('update-dialog', this.exibedialogInterno)
      },
      exibeBtnDownload () {
        return !navigator.userAgent.match(/iPhone/i)
      },
      generatePDF () {
        // var date = new Date()
        const doc = new JSPDF({
          orientation: 'portrait',
          unit: 'px',
          format: 'a4',
          compress: true,
        })
        doc
          .autoTable({
            styles: {
              fillColor: [0, 0, 0, 0.1],
              textColor: [0, 0, 0],
            },
            head: [['Chave de Acesso', 'Número NF-e', 'Versão']],
            body: [[this.nota.chavenfe, this.nota.numeronota, this.parseInteiro(this.nota.versarnfe)]],
          })
        if (this.nota.cancelada === 1) {
          doc.autoTable({
            body: [
              [{ content: 'NOTA FISCAL ELETRÔNICA CANCELADA', colSpan: 3, rowSpan: 1, styles: { halign: 'center', fillColor: [0, 0, 0, 0.1], textColor: [249, 25, 14] } }],
            ],
          })
        }
        doc.autoTable({
          body: [
            [{ content: 'Dados da NF-e', colSpan: 3, rowSpan: 1, styles: { halign: 'center', fillColor: [0, 0, 0, 0.3], textColor: [0, 0, 0] } }],
          ],
        })
        doc
          .autoTable({
            styles: {
              fillColor: [0, 0, 0, 0.1],
              textColor: [0, 0, 0],
            },
            head: [['Natureza da Operação', 'Tipo da Operação']],
            body: [[this.nota.natureza, '0 - Entrada']],
          })
        doc
          .autoTable({
            styles: {
              fillColor: [0, 0, 0, 0.1],
              textColor: [0, 0, 0],
            },
            head: [['Modelo', 'Série', 'Número', 'Data/hora Emissão']],
            body: [[this.nota.modelonota, this.nota.serienota, this.nota.numeronota, this.formatDiaMesAno(this.nota.dataemissao)]],
          })
        doc.autoTable({
          body: [
            [{ content: 'Emitente', colSpan: 3, rowSpan: 1, styles: { halign: '', fillColor: [0, 0, 0, 0.3], textColor: [0, 0, 0] } }],
          ],
        })
        doc
          .autoTable({
            styles: {
              fillColor: [0, 0, 0, 0.1],
              textColor: [0, 0, 0],
            },
            head: [['CNPJ', 'Inscrição Estadual', 'Nome / Razão Social']],
            body: [[this.empresaNota.cnpj, this.empresaNota.inscricaoestadual, this.empresaNota.razaosocial]],
          })
        doc
          .autoTable({
            styles: {
              fillColor: [0, 0, 0, 0.1],
              textColor: [0, 0, 0],
            },
            head: [['Município', 'UF']],
            body: [[this.nota.cidade, this.nota.estado]],
          })
        doc.autoTable({
          body: [
            [{ content: 'Destinatário', colSpan: 3, rowSpan: 1, styles: { halign: '', fillColor: [0, 0, 0, 0.3], textColor: [0, 0, 0] } }],
          ],
        })
        doc
          .autoTable({
            styles: {
              fillColor: [0, 0, 0, 0.1],
              textColor: [0, 0, 0],
            },
            head: [['CPF', 'Inscrição Estadual ', 'Nome / Razão Social']],
            body: [[this.nota.cpfcnpj, this.nota.inscricaoestadual, this.nota.nome]],
          })
        doc
          .autoTable({
            styles: {
              fillColor: [0, 0, 0, 0.1],
              textColor: [0, 0, 0],
            },
            head: [['Município', 'UF', 'País']],
            body: [[this.nota.cidade, this.nota.estado, '']],
          })
        doc.autoTable({
          body: [
            [{ content: 'Produtos', colSpan: 3, rowSpan: 1, styles: { halign: '', fillColor: [0, 0, 0, 0.3], textColor: [0, 0, 0] } }],
          ],
        })
        console.log(this.bodyData)
        const columns = [
          { title: 'Descrição', dataKey: 'nome' },
          { title: 'Quantidade', dataKey: 'quantidade' },
          { title: 'Unid. Com.', dataKey: 'unidade' },
          { title: 'Valor Unit.', dataKey: 'preco' },
          { title: 'Valor Prod.', dataKey: 'valortotalitem' },
        ]
        // + [[this.parseMoeda(totalItens, 2)]]
        doc
          .autoTable({
            styles: {
              fillColor: [0, 0, 0, 0.1],
              textColor: [0, 0, 0],
            },
            columns,
            body: this.itensNota,
          })
        doc
          .autoTable({
            styles: {
              fillColor: [0, 0, 0, 0.1],
              textColor: [0, 0, 0],
            },
            columnStyles: { 0: { halign: 'left' } },
            head: [['Incentivo', 'Valor Total']],
            body: [[this.nota.incentivo, this.computedSomaValorTotalNota]],
          })
        // footer
        doc
          .setFont('times')
          .setFontSize(11)
          .setTextColor(0, 0, 255)
          .text('Desenvolvido por: Magistech Sistemas - www.magistech.com.br', 5, doc.internal.pageSize.height - 0.9)
        //
        // Prepara documento para download
        const fileName = 'notaLeite_' + this.formatedDate(this.nota.dataemissao, 'YYYY-MM-DD') + '_' + Math.floor(Math.random() * 100) + '.pdf'
        this.notapdf = doc.output('dataurlstring', fileName)
        const downloadLink = document.createElement('a')
        downloadLink.href = this.notapdf
        downloadLink.download = fileName
        const acao = 'gerarPDF'
        const dados = [
          { funcao: acao },
          { link: downloadLink.href },
          { nomearquivo: fileName },
        ]
        const isWebView = localStorage.getItem('platform')
        if (isWebView === 'android' || isWebView === 'ios') {
          window.ReactNativeWebView.postMessage(JSON.stringify(dados))
        }
        downloadLink.click()
      },
    },
  }
</script>

<style scoped>
  .v-dialog > .v-card > .v-toolbar {
    position: sticky;
    top: 0;
    z-index: 999;
  }
  .totalizador { background-color: rgba(78, 119, 173, 0.2);}
  .totalizador td { font-weight: 500;}
  #btnDownload {
    position: fixed;
    top: 100px;
    right: 20px;
  }
</style>
